import { SelectV2, SelectV2Option } from '@cimplico/components';
import { useEffect, useState } from 'react';
import { useGroups } from '../../queries/use-groups';

type GroupSelectProps = {
    title?: string;
    isOptional?: boolean;
    isMulti?: boolean;
    placeholder?: string;
    form?: string;
    isDisabled?: boolean;
    defaultValue?: string;
    size?: 'small' | 'standard';
    onChange: (ids: string[]) => void;
};

function GroupSelect({
    title,
    isMulti = false,
    isOptional = false,
    placeholder,
    form,
    isDisabled,
    defaultValue,
    size,
    onChange,
}: GroupSelectProps): JSX.Element {
    const [selected, setSelected] = useState<SelectV2Option[]>([]);
    const [groupSearch, setGroupSearch] = useState('');
    const groupQuery = useGroups({ page: 1, search: groupSearch, sort: '', filter: '' });

    function handleGroupSelect(options: SelectV2Option[]): void {
        setSelected(options);
        onChange(options.map((o) => o.value as string));
    }

    useEffect(() => {
        if (defaultValue && groupQuery.data?.groups) {
            const matchingGroup = groupQuery.data.groups.find((g) => g.id === defaultValue);
            const defaultSelected: SelectV2Option[] = [{ label: matchingGroup?.name || '', value: defaultValue }];
            setSelected(defaultSelected);
        } else {
            setSelected([]);
        }
    }, [defaultValue, groupQuery.data?.groups]);

    return (
        <div>
            <SelectV2
                keepSelectedOptions
                placeholder={placeholder || 'Select a group...'}
                title={title}
                form={form}
                isOptional={isOptional}
                isMulti={isMulti}
                isLoading={groupQuery.isFetching || groupQuery.isLoading}
                options={(groupQuery.data?.groups || []).map((g) => ({ value: g.id, label: g.name }))}
                onSearch={setGroupSearch}
                onChange={handleGroupSelect}
                value={selected}
                disabled={isDisabled}
                size={size}
            />
        </div>
    );
}
export default GroupSelect;
